import { enumLoadStatus, LoadStatus } from '@rematter/frontend-lib-api-client';
import { isDefined, Maybe } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

export const canLoadBeMarkedAsReceived = (
  load: Maybe<{ status?: LoadStatus }>,
) => load?.status === enumLoadStatus.Shipped;

export const canLoadBeMarkedAsReviewed = (
  load: Maybe<{ status?: LoadStatus; reviewed?: boolean }>,
) => load?.status === 'Received' && !load.reviewed;

export const getLoadStatusColor = (status: Maybe<LoadStatus>): ThemeColor => {
  switch (status) {
    case 'Pending':
      return 'warning';
    case 'Received':
      return 'primary';
    case 'Reconciled':
      return 'success';
    case 'Shipped':
      return 'warning';
    case 'Unassigned':
      return 'neutral';
    case 'Voided':
      return 'failure';
    default:
      return 'neutral';
  }
};

export const formatLoadNumber = (loadNumber: Maybe<number>) =>
  isDefined(loadNumber) ? String(loadNumber).padStart(6, '0') : '—';
